// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Header_hover-underline__Hk9e\\+::after {
  content: "";
  position: absolute;
  width: 40%;
  transform: scaleX(0);
  height: 3px;
  bottom: 0;
  left: 14px;
  background-color: var(--accent-color);
  transform-origin: bottom right;
  transition: transform 0.3s ease-out;
  border-radius: 5px;
}

.Header_sidebar-icon__FiQYS:hover .Header_hover-underline__Hk9e\\+::after {
  transform: scaleX(1);
  transform-origin: bottom left;
}

.Header_dropDown-backDrop__5g9gY {
  position: fixed;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  background-color: var(--main-color);
  z-index: 99;
}

.Header_hover-underline-mobile__-WklB::after {
  content: "";
  position: absolute;
  width: 10%;
  transform: scaleX(0);
  height: 3px;
  bottom: 0;
  left: 0;
  background-color: var(--accent-color);
  transform-origin: bottom right;
  transition: transform 0.3s ease-out;
  border-radius: 5px;
}

.Header_sidebar-icon-mobile__eKqU1:hover .Header_hover-underline-mobile__-WklB::after {
  transform: scaleX(1);
  transform-origin: bottom left;
}

.Header_sidebar-icon-mobile__eKqU1 a {
  color: var(--main-color);
}

.Header_profile__HAAFc {
  display: flex;
  align-items: center;
}
.Header_profile__HAAFc .Header_profile-img__qKH4k {
  width: 40px;
  height: 40px;
  border-radius: 25px;
  object-fit: cover;
  margin-right: 5px;
}
.Header_profile__HAAFc .Header_user-name__hZG55 {
  font-size: 16px;
  font-weight: bolder;
  margin-bottom: 5px;
}
.Header_profile__HAAFc .Header_user-balance__Nil50 {
  font-weight: bolder;
  color: gold;
  font-size: 16px;
}
.Header_authActive__iiYjs {
  background-color: var(--text-color);
  border-radius: 50px;
  white-space: nowrap;
  padding: 0 10px;
}
.Header_authActive__iiYjs a {
  color: #000;
}
/* Tablet and IPad (portrait)
----------------------------------------------------------------------------- */
@media (min-width: 768px) and (max-width: 1024px) {
}

/* Tablet and IPad (landscape)
----------------------------------------------------------------------------- */
@media (min-width: 768px) and (max-width: 1024px) and (orientation: landscape) {
}

/* Low Resolution Tablet and Mobile (landscape)
----------------------------------------------------------------------------- */
@media (min-width: 481px) and (max-width: 767px) {
  .Header_profile__HAAFc .Header_user-name__hZG55 {
    font-size: 16px;
  }
  .Header_profile__HAAFc .Header_user-balance__Nil50 {
    font-size: 14px;
  }
}

/* Smartphones Mobiles (landscape)
----------------------------------------------------------------------------- */
@media (min-width: 320px) and (max-width: 480px) {
  .Header_profile__HAAFc .Header_user-name__hZG55 {
    font-size: 14px;
  }
  .Header_profile__HAAFc .Header_user-balance__Nil50 {
    font-size: 14px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/assets/styles/Header.module.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,kBAAkB;EAClB,UAAU;EACV,oBAAoB;EACpB,WAAW;EACX,SAAS;EACT,UAAU;EACV,qCAAqC;EACrC,8BAA8B;EAC9B,mCAAmC;EACnC,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;EACpB,6BAA6B;AAC/B;;AAEA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,SAAS;EACT,QAAQ;EACR,mCAAmC;EACnC,WAAW;AACb;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,UAAU;EACV,oBAAoB;EACpB,WAAW;EACX,SAAS;EACT,OAAO;EACP,qCAAqC;EACrC,8BAA8B;EAC9B,mCAAmC;EACnC,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;EACpB,6BAA6B;AAC/B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;AACA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,iBAAiB;EACjB,iBAAiB;AACnB;AACA;EACE,eAAe;EACf,mBAAmB;EACnB,kBAAkB;AACpB;AACA;EACE,mBAAmB;EACnB,WAAW;EACX,eAAe;AACjB;AACA;EACE,mCAAmC;EACnC,mBAAmB;EACnB,mBAAmB;EACnB,eAAe;AACjB;AACA;EACE,WAAW;AACb;AACA;+EAC+E;AAC/E;AACA;;AAEA;+EAC+E;AAC/E;AACA;;AAEA;+EAC+E;AAC/E;EACE;IACE,eAAe;EACjB;EACA;IACE,eAAe;EACjB;AACF;;AAEA;+EAC+E;AAC/E;EACE;IACE,eAAe;EACjB;EACA;IACE,eAAe;EACjB;AACF","sourcesContent":[".hover-underline::after {\n  content: \"\";\n  position: absolute;\n  width: 40%;\n  transform: scaleX(0);\n  height: 3px;\n  bottom: 0;\n  left: 14px;\n  background-color: var(--accent-color);\n  transform-origin: bottom right;\n  transition: transform 0.3s ease-out;\n  border-radius: 5px;\n}\n\n.sidebar-icon:hover .hover-underline::after {\n  transform: scaleX(1);\n  transform-origin: bottom left;\n}\n\n.dropDown-backDrop {\n  position: fixed;\n  top: 0;\n  left: 0;\n  bottom: 0;\n  right: 0;\n  background-color: var(--main-color);\n  z-index: 99;\n}\n\n.hover-underline-mobile::after {\n  content: \"\";\n  position: absolute;\n  width: 10%;\n  transform: scaleX(0);\n  height: 3px;\n  bottom: 0;\n  left: 0;\n  background-color: var(--accent-color);\n  transform-origin: bottom right;\n  transition: transform 0.3s ease-out;\n  border-radius: 5px;\n}\n\n.sidebar-icon-mobile:hover .hover-underline-mobile::after {\n  transform: scaleX(1);\n  transform-origin: bottom left;\n}\n\n.sidebar-icon-mobile a {\n  color: var(--main-color);\n}\n\n.profile {\n  display: flex;\n  align-items: center;\n}\n.profile .profile-img {\n  width: 40px;\n  height: 40px;\n  border-radius: 25px;\n  object-fit: cover;\n  margin-right: 5px;\n}\n.profile .user-name {\n  font-size: 16px;\n  font-weight: bolder;\n  margin-bottom: 5px;\n}\n.profile .user-balance {\n  font-weight: bolder;\n  color: gold;\n  font-size: 16px;\n}\n.authActive {\n  background-color: var(--text-color);\n  border-radius: 50px;\n  white-space: nowrap;\n  padding: 0 10px;\n}\n.authActive a {\n  color: #000;\n}\n/* Tablet and IPad (portrait)\n----------------------------------------------------------------------------- */\n@media (min-width: 768px) and (max-width: 1024px) {\n}\n\n/* Tablet and IPad (landscape)\n----------------------------------------------------------------------------- */\n@media (min-width: 768px) and (max-width: 1024px) and (orientation: landscape) {\n}\n\n/* Low Resolution Tablet and Mobile (landscape)\n----------------------------------------------------------------------------- */\n@media (min-width: 481px) and (max-width: 767px) {\n  .profile .user-name {\n    font-size: 16px;\n  }\n  .profile .user-balance {\n    font-size: 14px;\n  }\n}\n\n/* Smartphones Mobiles (landscape)\n----------------------------------------------------------------------------- */\n@media (min-width: 320px) and (max-width: 480px) {\n  .profile .user-name {\n    font-size: 14px;\n  }\n  .profile .user-balance {\n    font-size: 14px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"hover-underline": `Header_hover-underline__Hk9e+`,
	"sidebar-icon": `Header_sidebar-icon__FiQYS`,
	"dropDown-backDrop": `Header_dropDown-backDrop__5g9gY`,
	"hover-underline-mobile": `Header_hover-underline-mobile__-WklB`,
	"sidebar-icon-mobile": `Header_sidebar-icon-mobile__eKqU1`,
	"profile": `Header_profile__HAAFc`,
	"profile-img": `Header_profile-img__qKH4k`,
	"user-name": `Header_user-name__hZG55`,
	"user-balance": `Header_user-balance__Nil50`,
	"authActive": `Header_authActive__iiYjs`
};
export default ___CSS_LOADER_EXPORT___;
